import { createAxiosInstance } from './createAxiosInstance';

const axiosInstance = createAxiosInstance(import.meta.env.REACT_APP_URL);

export const API_ROUTES = {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    SIGNUP: '/auth/register',
    REGISTRATION: '/auth/sso/register',
    API_MANAGER: '/api-manager',
    API_MANAGER_EXCHANGE: '/api-manager/exchange',
    MARK_FAVORITE: '/api-manager/markAsFavorite',
    FIAT_SUMMARY: '/fiat/summary',
    BALANCES: '/wallet/balances',
    STORAGE: '/storage',
    ASSETS: '/assets',
    SSO_CONFIRM: '/auth/sso/login',
    VERIFY_EMAIL: '/auth/verifyToken',
    RESET_PASSWORD: '/auth/password/reset',
    CONFIRM_RESET_PASSWORD: '/auth/password/verify',
    RESEND_EMAIL: '/auth/verify/resend',
    OPEN_POSITIONS: '/open-positions',
    PERFORMANCE: '/performance',
    CANDLES: '/performance/candles',
    PULL_SERVICE: '/performance/pull',
    ORDER_TYPE_STATS: 'analytics/order-type-stats',
    JOURNAL: '/journal',
    TAGS: '/tags',
    NOTES: '/notes',
    SETTINGS: '/settings',
    PAYMENTS: '/payments',
    WITHDRAWAL_DEPOSIT: '/wallet/withdrawals-deposits',
    VERIFICATION_PAGES: '/verification-pages',
    TWITTER_GET_TOKEN: '/twitter/getRequestToken',
    TWITTER_VALIDATE_USER: '/twitter/validateUser',
    COUPONS: '/coupons',
    REQUEST_EXCHANGES: '/request-exchanges',
    BANNERS: '/banners',
    VALIDATE_PERMALINK: '/verification-pages/validate-permalink',
    TWITTER_USER_DATA: '/twitter/user',
    LEGS: '/legs',
    PNL_ANALYTICS: 'legs/analytics/pnl-detail',
    PNL_ANALYTICS_AGGREGATED: 'legs/analytics/pnl',
    PNL_DISTRIBUTION: 'legs/analytics/pnl-distribution',
    LEGS_NOTES: '/legs-notes',
    EMBEDS: '/embeds',
    LEGS_SUMMARY_ANALYTICS: '/legs/analytics/summary',
    LEGS_SYMBOLS_ANALYTICS: '/legs/analytics/symbols',
    LEGS_TAGS_ANALYTICS: '/legs/analytics/tags',
    LEGS_DURATION_ANALYTICS: '/legs/analytics/duration',
    LEGS_SIZE_ANALYTICS: '/legs/analytics/size',
    LEGS_DATE_TIME_ANALYTICS: '/legs/analytics/datetime',
    LEGS_FUTURES_ANALYTICS_PNL: '/legs/analytics/futures/pnl',
    LEGS_FUTURES_ANALYTICS_HL_PNL: '/exchanges/hyperliquid/portfolio',
    TRACKING_CLICKS: '/member-activity/clicks',
    STRAPI_CONNECTION: '/strapi-connection',
    TWITTER: '/twitter',
    TWITTER_CONNECT: '/twitter/connect',
    TWITTER_SYNC: '/twitter/sync',
    TWITTER_DISCONNECT: '/twitter/disconnect',
    TWITTER_REQUEST_TOKEN: '/twitter/request-token',
    CANVAS: '/canvas',
    GENERAL_BREAKEVEN: '/settings/breakeven',
    NOTIFICATIONS: '/notifications',
    LEADERBOARD: '/leader-board',
    REWARD_HUB: 'rewards-hub',
    X_FOLLOW: '/rewards-hub/x-follow',
    DISCORD_JOIN: '/rewards-hub/discord-join',
    INTELLIGENCE: '/intelligence',
    INTELLIGENCE_V2: '/intelligence/V2',
    SOCIAL_LOGIN: '/auth/social/login',
    SOCIAL_REGISTER: '/auth/social/register',
    CHECK_USER: 'auth/checkUsername',
    CALENDAR_LEG_INFO: '/legs/calendar',
    CALENDAR_NOTES: 'legs/calendar/notes',
    TELEGRAM: '/telegram',
    GLOBAL_UNLOCKED: '/global-unlocked',
    WALLET_HOLDINGS: '/wallet/holdings',
    SPOTS: 'legs/spots',
    CLIENT_STORAGE: '/client-storage',
};

export default axiosInstance;
